// extracted by mini-css-extract-plugin
export default {"root":"page_root__ZMxgE"};